// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"29192abe","196":"205640f3","232":"2c8ae826","453":"2cb4122f","586":"7541fb2c","591":"b024c0ff","824":"765ac893","988":"931c189f"}[chunkId] + ".chunk.js";
};